import React, { useContext, useEffect, useRef, useState } from "react";
import UserContext from "../../contexts/UserContext";
import Utils from "../../Utils";
import NotificationBell from "../NotificationBell";
import Notifications from "../common/Notifications";

const AppHeader = ({ userType }) => {
  const { userData, logout } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Determine badge and color based on userType
  let badge = "";
  let badgeColor = "#258b85";
  if (userType === "photographer") {
    badge = Utils.isPhotographer() ? "PG" : "HO";
    badgeColor = "#ca8c10";
  } else if (userType === "hotel") {
    badge = Utils.isAMT() ? "AM" : "HP";
    badgeColor = "#258b85";
  }

  return (
    <header className="header px-4 py-4 shadow-md sm:px-6 lg:px-8">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex min-w-0 items-center gap-4 sm:gap-8">
          <img
            src={`${process.env.PUBLIC_URL}/images/logo.png`}
            alt="Marriott Bonvoy"
            className="logo"
          />
          <span className="hidden min-w-0 items-center gap-2 sm:flex">
            <div
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white"
              style={{ backgroundColor: badgeColor }}
            >
              {badge}
            </div>
            <h3 className="truncate text-base font-semibold text-gray-700 lg:text-lg">
              {Utils.panelTitle()}
            </h3>
          </span>
        </div>
        <nav className="right-0 top-full z-20 mt-3 w-full sm:static sm:mt-0 sm:w-auto">
          <ul
            className={`${open ? "flex" : "hidden"} ml-auto w-full flex-col gap-3 rounded-lg border border-gray-200 bg-white p-4 font-bold shadow-lg sm:flex sm:w-auto sm:flex-row sm:items-center sm:justify-end sm:gap-6 sm:border-0 sm:bg-transparent sm:p-0 sm:shadow-none`}
          >
            <li>
              <NotificationBell NotificationListComponent={Notifications} />
            </li>
            <li>
              <a
                href={`${process.env.PUBLIC_URL}/dashboard`}
                className="block text-gray-600 hover:text-blue-500"
                onClick={() => setOpen(false)}
              >
                Dashboard
              </a>
            </li>
            <li>
              <a
                href={`${process.env.PUBLIC_URL}/resource-hub`}
                className="block text-gray-600 hover:text-blue-500"
                onClick={() => setOpen(false)}
              >
                Photography Resource Hub
              </a>
            </li>
            {Utils.hasArchiveAccess() && (
              <li>
                <a
                  href={`${process.env.PUBLIC_URL}/archives`}
                  className="block text-gray-600 hover:text-blue-500"
                  onClick={() => setOpen(false)}
                >
                  Photography Archives
                </a>
              </li>
            )}
            <li className="flex items-center justify-between gap-3 border-t border-gray-100 pt-3 sm:border-0 sm:pt-0">
              <span className="min-w-0 truncate text-gray-700">
                {userData?.name || "User"}
              </span>
              <a
                href="#"
                onClick={(event) => {
                  setOpen(false);
                  logout(event);
                }}
                title="Logout"
                className="shrink-0 text-gray-600 hover:text-blue-500"
              >
                <i className="fas fa-sign-out-alt"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default AppHeader;
